module.exports = __webpack_public_path__ + "static/img/test2.cdcc6ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test/test2.jpg
// module id = KAW2
// module chunks = 2